import { Reveal } from "@/components/common/Reveal";

const STEPS = [
  { step: "Time to be heard", description: "Every visit begins with an unhurried conversation about your concerns and goals." },
  { step: "Careful diagnosis", description: "Digital imaging and thorough examination reveal the full picture first." },
  { step: "Clear treatment options", description: "We explain every option honestly — trade-offs, timelines, and costs." },
  { step: "Precision-driven treatment", description: "Guided, digital workflows let us treat conservatively and accurately." },
  { step: "Long-term oral health", description: "We plan for durability and prevention, for years to come." },
];

export const CdtStandard = ({ title = "The CDT Standard" }) => (
  <div data-testid="cdt-standard">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
      {STEPS.map((s, i) => (
        <Reveal key={s.step} delay={i * 0.06}>
          <div className="h-full rounded-[var(--cdt-radius-md)] bg-[var(--cdt-surface-2)] border border-[color:var(--cdt-border)] p-5">
            <div className="font-display text-2xl text-[var(--cdt-accent)]">{String(i + 1).padStart(2, "0")}</div>
            <h3 className="font-semibold mt-2 text-[var(--cdt-text)] text-[15px]">{s.step}</h3>
            <p className="mt-2 text-sm leading-6 text-[var(--cdt-muted)]">{s.description}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
);
